import { post, get } from '../request'
import { API_SUCCESS, API_FAILURE } from '~/helper/constant/api_status'
import ApiResponse from '~/model/response'

export const getAdminDashboardFilter = (token, from, to, time) => {
    console.log("service", token)
    return new Promise(function (resolve, reject) {
        try {
            get(`dashboard/report/${from}/${to}/${time}`, token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const getAdminDashboardAll = (token) => {
    return new Promise(function (resolve, reject) {
        try {
            get('dashboard/all', token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const getAdminDashboard = (id, token) => {
    return new Promise(function (resolve, reject) {
        try {
            get('dashboard/get/' + id, token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const getAdminDashboardStatus = (id, token) => {
    return new Promise(function (resolve, reject) {
        try {
            get('dashboard/status' + id, token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const addAdminDashboard = (data, token) => {
    return new Promise(function (resolve, reject) {
        try {
            post('/dashboard/add', token, data).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const updateAdminDashboard = (id, data, token) => {
    return new Promise(function (resolve, reject) {
        try {
            post('dashboard/update/' + id, token, data).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}



export const deleteAdminDashboard = (id, token) => {
    return new Promise(function (resolve, reject) {
        try {
            post('dashboard/delete/' + id, token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}
